<template>
  <div>
    <el-dialog title="重置签署密码" :visible.sync="dialogVisible" width="450px" :before-close="handleClose"
               @close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
        <el-form-item prop="newPassword" label="新密码">
          <el-input show-password v-model="ruleForm.newPassword" placeholder="请输入新独立签署密码"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码">
          <el-input show-password v-model="ruleForm.confirmPassword" placeholder="请再次输入独立签署密码"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" label="验证码">
          <el-input maxlength="6"
                    v-model="ruleForm.captcha"
                    placeholder="短信验证码">
          </el-input>
          <div v-if="!hadSend" class="get-cap" @click="getCaptcha">获取验证码</div>
          <div v-if="hadSend" class="get-cap">{{ count }}s重新获取</div>
          <!--          <el-button type="text" class="captcha-btn" @click="getCaptcha" :disabled="!captchaAble">{{ captchaTitle }}-->
          <!--          </el-button>-->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <verify-code ref="verifyRef" @getMessage="getMessage"></verify-code>
  </div>
</template>
<script>
import verifyCode from "@/components/VerifyCode.vue";

export default {
  components: {verifyCode},
  data() {
    var validNewPass = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (value === "") {
        callback(new Error("请设置新独立签署密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须为6位数字"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入确认独立签署密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      ruleForm: {
        newPassword: undefined,
        confirmPassword: undefined,
        captcha: undefined,
      },
      rules: {
        newPassword: [
          {required: true, validator: validNewPass, trigger: "blur"}
        ],
        confirmPassword: [
          {required: true, validator: validatePass2, trigger: "blur"}
        ],
        captcha: [
          {required: true, message: '请输入验证码', trigger: "blur"}
        ]
      },
      loading: false,
      captchaAble: true,
      captchaTitle: '获取验证码',

      hadSend: false,
      count: 60,
      timer: null
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    getCaptcha() {
      this.$refs.verifyRef.show(JSON.parse(localStorage.getItem('user')).code);
    },
    getMessage(param) {
      let params = param;
      params.telephone = this.ruleForm.telephone;
      this.loading = true;
      this.$http.post(this.$api.user.sendSMSCode, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.hadSend = true;
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              if (this.timer) {
                this.hadSend = false;
                clearInterval(this.timer);
              }
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    sendCaptcha() {
      if (!this.captchaAble) {
        return
      }

      this.captchaAble = false
      this.$http.get(this.$api.user.sendSMSCode).then(res => {
        if (res.data.code == 200) {
          this.$message.success('验证码已发送')

          if (this._timerId) {
            clearInterval(this._timerId)
            this._timerId = 0
          }

          this._currTime = 60
          this._timerId = setInterval(() => {
            this._currTime--;
            if (this._currTime <= 0) {
              this.captchaAble = true
              this.captchaTitle = '获取验证码'
              clearInterval(this._timerId)
              this._timerId = 0
            } else {
              this.captchaTitle = '重新获取(' + this._currTime + ')'
            }
          }, 1000);
        } else {
          this.captchaAble = true
          this.$message.error(res.data.msg || "验证码发送失败")
        }
      }).catch(() => {
        this.captchaAble = true
        this.$message.error("验证码发送失败")
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(async value => {
        if (value) {
          this.$http.post(this.$api.user.retrievePincode, {
            pinCode: this.ruleForm.newPassword,
            code: this.ruleForm.captcha
          }, {'Content-Type': 'application/x-www-form-urlencoded'}).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功')
            } else {
              this.$message.error(res.data.msg)
            }
          })

          this.handleClose();
        }
      });
    },
    handleClose() {
      this.loading = false;
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.captcha-item {
  position: relative;
}

.get-cap {
  position: absolute;
  right: 20px;
  top: 0;
  color: #407fff;
  cursor: pointer;
}

.captcha-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 20px;
  margin: 11px 0;
  height: 20px;
  line-height: 20px;
  box-sizing: border-box;
  border-left: 1px solid #eee;
}

.sub-button {
  width: 138px;
  height: 42px;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 30px 0;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
